import { Outlet } from 'react-router-dom';
import { GlobalProvider } from "./contexts/globalContext";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AnalyticsTracker from "./components/AnalyticsTracker";
import AnalyticsConsentBanner from "./components/AnalyticsConsentBanner";

function App() {
  return (
    <GlobalProvider>
    <ScrollToTop />
    <AnalyticsTracker />
      
    <Header />
    <main className="py-3">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-6">
      <Outlet/>
      </div>
    </main>
    <Footer />
    <AnalyticsConsentBanner />
    <Toaster richColors position="bottom-right" />
    
    </GlobalProvider>
  )
}

export default App
